import URI from "urijs";

const localServiceLabels = new Set(["secure", "www"]);

/**
 * Returns a parent domain that storefront and checkout cookies can share.
 *
 * Local worktree hosts have one more label than public domains, so URI.js's
 * registrable-domain lookup would incorrectly reduce
 * `www.pantryshop.main.localhost` to `main.localhost`.
 */
export const getCookieDomain = (
  hostname = typeof window === "undefined"
    ? undefined
    : window.location.hostname
): string | undefined => {
  const normalizedHostname = hostname
    ?.toLowerCase()
    .replace(/^\[(.*)\]$/, "$1")
    .replace(/\.$/, "");

  if (
    !normalizedHostname ||
    normalizedHostname === "localhost" ||
    !normalizedHostname.includes(".") ||
    normalizedHostname.includes(":")
  ) {
    return undefined;
  }

  if (normalizedHostname.endsWith(".localhost")) {
    const [serviceLabel, ...sharedDomainLabels] = normalizedHostname.split(".");

    return localServiceLabels.has(serviceLabel) &&
      sharedDomainLabels.length >= 2
      ? sharedDomainLabels.join(".")
      : undefined;
  }

  return URI(`//${normalizedHostname}`).domain() || undefined;
};
